import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-wyoming-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./wyoming-state-form.component.html",
  styleUrl: "./wyoming-state-form.component.scss",
})
export class WyomingStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
